import {
  getSessionStorageItem,
  removeSessionStorageItem,
  setSessionStorageItem,
} from "../../utils/clientStorageUtils";

/** Rows written before `update_pax` full reload; rehydrated into the V2 form on next load. */
export interface PaxReloadExcelRestorePayload {
  travellerData: {
    name: string;
    dob: string;
    gender: string;
    passport: string;
    nomineeName?: string;
    isSelected: boolean;
    isEdited?: boolean;
    isSavedTraveller?: boolean;
    isExcelUploaded?: boolean;
    travellerId?: number | string;
    infoSource?: string;
  }[];
  fileName: string;
  /** data: URL from FileReader, when file is small enough to persist */
  fileDataUrl?: string;
  forceShowAll?: boolean;
}

const SESSION_KEY = "insurance_traveller_v2_pax_reload_excel";
const TOAST_COOKIE = "insurance_mweb_pax_update_toast";
const TOAST_MAX_AGE_SEC = 180;

export function setPostReloadPaxToastCookie(message: string): void {
  if (typeof document === "undefined" || !message) return;
  const encoded = encodeURIComponent(message);
  document.cookie = `${TOAST_COOKIE}=${encoded}; path=/; max-age=${TOAST_MAX_AGE_SEC}; SameSite=Lax`;
}

/** Read and delete the one-shot toast cookie (call once after load). */
export function consumePostReloadPaxToastCookie(): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(
    new RegExp(
      `(?:^|; )${TOAST_COOKIE.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}=([^;]*)`
    )
  );
  if (!match?.[1]) return null;
  let text: string;
  try {
    text = decodeURIComponent(match[1]);
  } catch {
    text = match[1];
  }
  document.cookie = `${TOAST_COOKIE}=; path=/; max-age=0; SameSite=Lax`;
  return text || null;
}

export function setPaxReloadExcelRestore(
  payload: PaxReloadExcelRestorePayload
): void {
  if (typeof window === "undefined") return;
  try {
    setSessionStorageItem(SESSION_KEY, payload, true);
  } catch (e) {
    console.error("Failed to persist pax-reload excel state:", e);
  }
}

export function peekPaxReloadExcelRestore(): PaxReloadExcelRestorePayload | null {
  if (typeof window === "undefined") return null;
  try {
    const v = getSessionStorageItem(SESSION_KEY, true);
    if (
      v &&
      typeof v === "object" &&
      Array.isArray((v as PaxReloadExcelRestorePayload).travellerData)
    ) {
      return v as PaxReloadExcelRestorePayload;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function clearPaxReloadExcelRestore(): void {
  if (typeof window === "undefined") return;
  try {
    removeSessionStorageItem(SESSION_KEY);
  } catch {
    /* ignore */
  }
}
